import EmailEditMessage from '@/components/configs/emails/editmessage/EmailEditMessage.vue'
import EmailEditTemplate from '@/components/configs/emails/edittemplate/EmailEditTemplate.vue'
import EmailTestSend from '@/components/configs/emails/testsend/EmailTestSend.vue'
import MessageBox from '@/components/common/messagebox/MessageBox.vue'

export default {
  name: 'ConfigEmailsList',
  data () {
    return {
      isMounted: false,
      loading: false,
      paging: {
        'sent-messages': {
          page: 1,
          pages: 1,
          limit: 50,
          total: 0
        }
      },
      itemData: {
        messages: [],
        templates: [],
        'sent-messages': []
      },
      filterValues: {
        messages: {},
        templates: {},
        'sent-messages': {
          to: '',
          status: null
        }
      },
      currentReq: null
    }
  },
  components: {
    EmailEditMessage,
    EmailEditTemplate,
    EmailTestSend,
    MessageBox
  },
  computed: {
    tableHeaders () {
      const headers = {
        messages: [
          { key: 'title.' + this.$i18n.locale, label: this.$t('general.email.title') },
          { key: 'code', label: this.$t('general.email.template.code') }
        ],
        templates: [
          { key: 'code', label: this.$t('general.email.template.code') }
        ],
        'sent-messages': [
          { key: 'subject', label: this.$t('general.email.title') },
          { key: 'to', label: this.$t('general.email.to'), format: 'formatFunc', funcs: [this.formatReceiver, this.formatReceiverOverwrite], classFuncs: [this.formatReceiverClass, this.formatReceiverOverwriteClass], filterKey: 'to' },
          { key: 'cc', label: this.$t('general.email.cc'), format: 'formatFunc', funcs: [this.formatReceiver, this.formatReceiverOverwrite], classFuncs: [this.formatReceiverClass, this.formatReceiverOverwriteClass] },
          { key: 'bcc', label: this.$t('general.email.bcc'), format: 'formatFunc', funcs: [this.formatReceiver, this.formatReceiverOverwrite], classFuncs: [this.formatReceiverClass, this.formatReceiverOverwriteClass] },
          { key: 'from', label: this.$t('general.email.from') },
          { key: 'message.code', label: this.$t('general.email.template.code') },
          { key: 'sentTimes', label: this.$t('general.email.sentTimes') },
          { key: 'sentTs', label: this.$t('general.email.sentTs'), type: 'datetime' },
          { key: 'errors', label: this.$t('general.email.errors') },
          { key: 'status_id', label: this.$t('general.email.status'), format: 'formatFromConfig', configKey: 'mail_statuses', configParam: 'name', filterKey: 'status' }
        ]
      };
      if (this.canEdit) {
        headers.messages.push(
          {
            key: 'actions',
            label: '',
            actions: [
              { label: this.$t('menu.config.emails.messages.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
              { label: this.$t('menu.config.emails.messages.test-send'), emit: 'testEmailSend', icon: 'secondary', bicon: 'envelope-fill' }
            ]
          }
        );
        headers.templates.push(
          { key: 'actions', label: '', actions: [{ label: this.$t('menu.config.emails.templates.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] }
        )
        headers['sent-messages'].push(
          { key: 'actions', label: '', actions: [{ label: this.$t('menu.config.emails.sent-messages.send'), emit: 'sendMessage', icon: 'secondary', bicon: 'envelope-fill' }] }
        )
      }

      return headers;
    },
    tableActions () {
      return {
        messages: {
          add: { title: this.$t('menu.config.emails.messages.add') }
        },
        templates: {
          add: { title: this.$t('menu.config.emails.templates.add') }
        },
        'sent-messages': {}
      }
    },
    tableExpandConfig () {
      return {
        messages: null,
        templates: null,
        'sent-messages': { component: 'ConfigEmailsMailMessageListExpand' }
      };
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    tableFilterConfig () {
      const filters = {
        messages: {},
        templates: {},
        'sent-messages': {
          to: { type: 'text', label: '', colOnlyFilter: true },
          status: { type: 'select', label: '', options: this.statusOptions, colOnlyFilter: true }
        }
      };
      return filters;
    },
    statusOptions () {
      const options = this.$store.getters.getConfigOptions('mail_statuses', this.$i18n.locale);
      options.unshift({ value: null, text: '' });
      return options;
    }
  },
  methods: {
    changePage (page, key) {
      this.paging[key].page = page;
      this.getTableData(key);
    },
    editItem (data, key) {
      this.$refs['edit-' + key].show(data);
    },
    getTableData (section = '') {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      const self = this;
      let path = 'config/emails';
      if (section) {
        path += '/' + section + '?g=1'
        if (this.paging[section]) {
          path += '&perPage=' + this.paging[section].limit + '&page=' + this.paging[section].page;
        }
        path = this.ApiRequest.addGetParamsToPath(path, this.filterValues[section], true);
      } else {
        path += '?perPage=' + this.paging['sent-messages'].limit;
      }
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          if (section) {
            self.itemData[section] = response.data.items;
            if (response.data.paging) {
              self.paging[section] = response.data.paging;
            }
          } else {
            for (const key in response.data) {
              self.itemData[key] = response.data[key].items;
              if (response.data[key].paging) {
                self.paging[key] = response.data[key].paging;
              }
            }
          }
          self.loading = false;
        }
      });
    },
    sendMessage (el, approved = false) {
      if (approved) {
        el.loading = true;
        this.$refs['table-sent-messages'][0].$forceUpdate();
        const self = this;
        this.ApiRequest.request('config/emails/send-email/' + el.id, this.ApiRequest.REQUEST_GET, {}, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.getTableData('sent-messages');
          }
          el.loading = false;
          self.$refs['table-sent-messages'][0].$forceUpdate();
        });
      } else {
        this.$refs.sendEmailMsgBox.show(el, this.$t('general.email.sendEmailTitle'), this.$t('general.email.sendEmailMessage'));
      }
    },
    testEmailSend (el) {
      this.$refs['test-send'].show(el);
    },
    formatReceiver (value, data) {
      return value;
    },
    formatReceiverOverwrite (value, data) {
      if (data.field.key === 'to') {
        return data.item.receiverOverwrite;
      }
    },
    formatReceiverClass (value, data) {
      let elClass = 'text-break';
      if (data.item.receiverOverwrite) {
        elClass += ' text-strikethrough';
      }
      return elClass;
    },
    formatReceiverOverwriteClass (value, data) {
      return 'text-break';
    }
  },
  mounted () {
    this.isMounted = true;
    this.getTableData();
  }
}
